import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _window;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable react-hooks-ssr/react-hooks-global-ssr */


import useReactMeasure from 'react-use-measure';
import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
/**
 * thin pre-polyfilled wrapper around `react-use-measure`
 * @see https://github.com/react-spring/react-use-measure
 */

export var useMeasure = function useMeasure(opts) {
  return useReactMeasure(_objectSpread(_objectSpread({}, opts), {}, {
    polyfill: Polyfill
  }));
};
/**
 * resize observer polyfill
 */

export var ResizeObserver = typeof window === 'undefined' || !((_window = window) === null || _window === void 0 ? void 0 : _window.ResizeObserver) ? Polyfill : window.ResizeObserver;